import React, { useEffect, useState } from "react"
import { Button, Col, Container, Form, Spinner, Row, Alert } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import SparkApi from "../api/SparkApi";
import { Shimmer } from "react-shimmer";
import Image from 'react-bootstrap/Image'
import jwt_decode from "jwt-decode";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import { whenGoogleMapsReady, createMap } from "../utils/googleMapsHelper";

const UserTracking = () => {
  const [body, setBody] = useState();
  const [userInfo, setUserInfo] = useState(
    jwt_decode(localStorage.getItem("token"))
  );
  console.log('userInfo', userInfo)
  const [body2, setBody2] = useState();
  const [selectedFiles, setSelectedFiles] = useState();
  const [locationPicFiles, setLocationPicFiles] = useState([]);
  const [locationPicPreviews, setLocationPicPreviews] = useState([]);
  const [thumbnail, setThumbnail] = useState(null);

  const FILE_SIZE_LIMIT = 20 * 1024 * 1024;

  const location = useLocation();
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [remarks, setRemarks] = useState();
  const [result, setResult] = useState()
  const [buttonDisabled, setButtonDisabled] = useState(false)
  const [locationRecord, setLocationRecord] = useState({});
  const [currentrecord, setCurrentrecord] = useState();
  const [spinner, setSpinner] = useState(false);
  const [alert, setAlert] = useState(null);
  const [address, setAddress] = useState()
  //New Fields State Added By Farhan Khan on 06-Nov-2024
  const [usertrackingRec, setUserTrackingRecords] = useState({});

  // New Change : here we use UseNavigate hook to navigate on lead create page
  const navigate = useNavigate();

  const handleVisitUpload = (event) => {
    setBody(URL.createObjectURL(event.target.files[0]));
    setSelectedFiles(event.target.files[0]);
  };

  const revokeLocationPicPreviews = (previews) => {
    previews.forEach((p) => URL.revokeObjectURL(p.url));
  };

  const handleSiteUpload = (event) => {
    const fileList = event.target.files;
    if (!fileList || fileList.length === 0) {
      revokeLocationPicPreviews(locationPicPreviews);
      setLocationPicPreviews([]);
      setLocationPicFiles([]);
      return;
    }

    const validFiles = [];
    const previews = [];

    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i];
      if (file.size > FILE_SIZE_LIMIT) {
        toast.error(`${file.name}: File should be less than 20MB`);
        continue;
      }
      if (!file.type.startsWith("image/")) {
        toast.error(`${file.name}: Only image files are allowed`);
        continue;
      }
      validFiles.push(file);
      previews.push({ url: URL.createObjectURL(file), name: file.name });
    }

    revokeLocationPicPreviews(locationPicPreviews);
    setLocationPicPreviews(previews);
    setLocationPicFiles(validFiles);
  };

  useEffect(() => {

    if (alert) {
      setTimeout(() => {
        // setAlert(null);
      }, 3000)
    }
  }, [alert])
  const [data, setdata] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        let loginusermanager = await SparkApi.fetchUserById(userInfo.managerid);
        console.log('loginusermanager', loginusermanager);
        setdata(loginusermanager);
      } catch (error) {
        console.error('Error fetching user:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    async function init() {

      let userdata = await SparkApi.getRecordOfTracking();
      console.log('userdata:', userdata);
      setCurrentrecord(userdata);
      setLocationRecord(userdata);
      if (userdata.logindatetime != null && userdata.logoutdatetime == null) {
        setButtonDisabled(true)
        setRemarks(userdata.remarks)
        setUserTrackingRecords(userdata); // For Edit Time Check-Out (Added By Farhan Khan on 06-Nov-2024)
      } else if (
        userdata.logindatetime &&
        userdata.logoutdatetime &&
        userdata.logindatetime.length &&
        userdata.logoutdatetime.length
      ) {
        setRemarks(userdata.remarks);
        setButtonDisabled(false);
      }

    }
    init();

    let mounted = true;
    whenGoogleMapsReady(() => {
      if (mounted) myMap();
    });
    return () => {
      mounted = false;
    };
  }, []);

  const myMap = async () => {
    var mapProp = {
      center: new window.google.maps.LatLng(latitude ? latitude : 12, longitude ? longitude : 12),
      zoom: 14,
    };

    const locate = window.navigator && window.navigator.geolocation;
    const currentCoords = { lat: 0, lng: 0 };

    if (locate) {
      locate.getCurrentPosition((position) => {
        currentCoords.lat = position.coords.latitude;
        currentCoords.lng = position.coords.longitude;
        setLatitude(position.coords.latitude);
        setLongitude(position.coords.longitude);
        mapProp = {
          center: new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude),
          zoom: 14,
        }

        const map = createMap("googleMap", mapProp);
        if (!map) return;

        var geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: currentCoords }, function (results, status) {
          let cur_address = results && results.length > 0 ? results[0].formatted_address : '';
          setAddress(cur_address);
          var marker = new window.google.maps.Marker({
            map: map,
            position: { lat: currentCoords.lat, lng: currentCoords.lng },
            title: cur_address,
            content: cur_address,
          });

          var infowindow = new window.google.maps.InfoWindow({
            content: cur_address
          });
          marker.addListener("click", () => {
            infowindow.open({
              anchor: marker,
              map,
            });
          });

        });

      }, (error) => {
      }, { maximumAge: 10000, timeout: 5000, enableHighAccuracy: true }
      )
    }

    setTimeout(() => {
      //////('mapProp => ', mapProp)


    }, 500)

  }

  const emailInfo = {
    to: "",
    editorHtml: "",
    subject: "",
    from: "",
    ownerid: userInfo.id,
    parentid: "",
  };



  const setLatLongJs = async (checkIn) => {
    const locate = window.navigator && window.navigator.geolocation;
    if (locate) {
      console.log('locate', locate)
      console.log('address checkin', address);
      console.log('remark checkin', remarks)
      locate?.getCurrentPosition(async (position) => {
        console.log('call')
        const now = new Date();
        const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
        const istDateTime = new Date(now.getTime() + istOffset);

        const logindatetime = istDateTime;

        if (checkIn) {

          let res = await SparkApi.createCheckInRecord({ 'logindatetime': new Date(), loginlattitude: position.coords.latitude.toString(), loginlongitude: position.coords.longitude.toString(), remarks, location: address, attandancetype: "Tracking Attendance",'client_name': usertrackingRec.client_name,'phone_no':usertrackingRec.phone_no,'referral_partner_name':usertrackingRec.referral_partner_name,'referral_number' : usertrackingRec.referral_number ,'postal_address' : usertrackingRec.postal_address });//New Fields Added By Farha Khan on 06-Nov-2024
          console.log('res', res)
          if (res && locationPicFiles.length > 0) {
            const formData = new FormData();
            for (let i = 0; i < locationPicFiles.length; i++) {
              formData.append(`files${i}`, locationPicFiles[i]);
            }
            const result = await SparkApi.createFile(res.id, formData);
            console.log('result', result)
          }
          setTimeout(async () => {
            if (res) {
              setButtonDisabled(true);
              setLocationRecord(res);
              revokeLocationPicPreviews(locationPicPreviews);
              setLocationPicPreviews([]);
              setLocationPicFiles([]);
              setAlert({ message: 'You have been Successfully Checked In.', type: 'success' });

              emailInfo.to = userInfo.email;
              emailInfo.cc = data.email;
              emailInfo.editorHtml = `<div class="container">
                    <h3>User Check-in Notification</h3>
                    <p>User: <strong>${userInfo.username}</strong>,</p>
                    <p>Successfully checked in to ${address}.</p>
                    <div class="location-info">
                        <p><strong>Date:</strong> ${moment(res.logindatetime).format("DD-MM-YYYY")}</p>
                        <p><strong>Time:</strong> ${moment(res.logindatetime).format("HH:mm:ss")}</p>
                    </div>
                    <p><br></p>
                </div>`;
              emailInfo.subject = "User Tracking";
              emailInfo.from = `${userInfo.username} <${userInfo.email}>`;
              console.log('emailInfo', emailInfo);
              emailInfo.parentid = userInfo.id;
              const emailSend = await SparkApi.sendEmailTask(emailInfo);
              console.log('emailSend', emailSend);





            } else {
              setAlert({ message: 'Something Went Wrong.', type: 'danger' });
            }
          }, 500);

        } else {
          //////('false',result);
          console.log('else call', address)
          let res;
          res = await SparkApi.handlCheckOut({ ...locationRecord, 'logoutdatetime': new Date(), 'logoutlattitude': position.coords.latitude.toString(), 'logoutlongitude': position.coords.longitude.toString(), 'remarks': remarks,'client_name': usertrackingRec.client_name,'phone_no':usertrackingRec.phone_no,'referral_partner_name':usertrackingRec.referral_partner_name,'referral_number' : usertrackingRec.referral_number ,'postal_address' : usertrackingRec.postal_address })//New Fields Added By Farha Khan on 06-Nov-2024
          setTimeout(async () => {
            if (res) {
              setButtonDisabled(false);
              setAlert({ message: 'You have been Successfully Checked Out.', type: 'success' });


              // userInfo.email = 'shivangi.t@ibirdsservices.com'
              // data.email = 'shivangitak9@gmail.com'

              emailInfo.to = userInfo.email;
              emailInfo.cc = data.email;
              emailInfo.editorHtml = `<div class="container">
                    <h3>Check-Out Notification</h3>
                    <p>User: <strong>${userInfo.username}</strong>,</p>
                    <p>Successfully checked in to ${address}.</p>
                    <div class="location-info">
                        <p><strong>Date:</strong> ${moment(res.logindatetime).format("DD-MM-YYYY")}</p>
                        <p><strong>Time:</strong> ${moment(res.logindatetime).format("HH:mm:ss")}</p>
                    </div>
                    <p><br></p>
                </div>`;
              emailInfo.subject = "User Tracking";
              emailInfo.from = `${userInfo.username} <${userInfo.email}>`;
              console.log('emailInfo', emailInfo);
              emailInfo.parentid = userInfo.id;
              const emailSend = await SparkApi.sendEmailTask(emailInfo);
              console.log('emailSend', emailSend);
              emailInfo.to = `${data.email}`;
              const emailSendagain = await SparkApi.sendEmailTask(emailInfo);
              console.log('emailSend', emailSendagain);
            } else {
              setAlert({ message: 'Something Went Wrong.', type: 'danger' });
            }
          }, 500);


        }
      }, (error) => {
        //////('error in location -> ', error) 
      })
    }
  }

  const handleCheckIn = async () => {
    if (address && address.trim() != "") {
      setLocationRecord({});
      setLatLongJs(true);
    }
    else {
      toast.error("Please provide address");
    }
  }

  const handleCheckOut = async () => {
    if (address && address.trim() != "") {
      setLatLongJs(false);
    }
    else {
      toast.error("Please provide address");
    }

  }

  const handleremarkChange = (e) => {
    setRemarks(e.target.value);
  }

  const handleAddressChange = (e) => {
    console.log('call', e)
    setAddress(e.target.value);
  }

  //Added By Farhan Khan on 06-Nov-2024 for new Fields HandleChange.
  const handleChange = (e) => {
    setUserTrackingRecords({ ...usertrackingRec, [e.target.name]: e.target.value });
  };

  return (
    <div className='p-4'>
      <Container >
        <ToastContainer />
        <Row className="view-form">
          <Col lg={8}>

            <Row className="">
              <Col>
                {alert && <Alert variant={alert.type} onClose={() => setAlert(false)} style={{ width: '100%', padding: '15px', margin: "0px 0px 5px 0px", fontWeight: 'bold', textAlign: 'center' }}>
                  {alert.message}
                </Alert>}
                {spinner && <Shimmer height={500} ></Shimmer>}
                {!spinner && <div id="googleMap" style={{ width: '100%', height: '300px', border: '1px solid black' }}>

                </div>}
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="" style={{ padding: '0' }} controlId="formAddress">
                  <Form.Label className="form-view-label" htmlFor="formAddress">Address</Form.Label>
                  <Form.Control
                    type="text"
                    name="address"
                    placeholder="Enter Address"
                    value={address}
                    onChange={handleAddressChange}
                  />

                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col
              >
                <Form.Group className="" style={{ padding: '0' }} controlId="formBasicFirstName">
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicFirstName"
                  >
                    Remarks
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    name="remarks"
                    value={remarks}
                    placeholder="Enter remarks.."
                    onChange={handleremarkChange}
                  />
                  {/* {errors.name && touched.name ? (
                    <p className="form-error" style={{ color: "red" }}>
                      {errors.name}
                    </p>    
                  ) : null} */}
                </Form.Group>
              </Col>
              {/* Added By Farhan Khan on 06-Nov-2024 New Fields Added as per Client Requested */}
              <Col
              >
                <Form.Group className="" style={{ padding: '0' }} controlId="formBasicFirstName">
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicFirstName"
                  >
                    Client Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="client_name"
                    value={usertrackingRec.client_name}
                    placeholder="Enter Client Name.."
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>  
            </Row>
            <Row>
            <Col
              >
                <Form.Group className="" style={{ padding: '0' }} controlId="formBasicFirstName">
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicFirstName"
                  >
                   Phone Number
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="phone_no"
                    value={usertrackingRec.phone_no}
                    placeholder="Enter Phone No.."
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col
              >
                <Form.Group className="" style={{ padding: '0' }} controlId="formBasicFirstName">
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicFirstName"
                  >
                    Referral Partner Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="referral_partner_name"
                    value={usertrackingRec.referral_partner_name}
                    placeholder="Enter Referral Partner Name.."
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
            <Col
              >
                <Form.Group className="" style={{ padding: '0' }} controlId="formBasicFirstName">
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicFirstName"
                  >
                    Referral Number
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="referral_number"
                    value={usertrackingRec.referral_number}
                    placeholder="Enter Referral Number.."
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col
              >
                <Form.Group className="" style={{ padding: '0' }} controlId="formBasicFirstName">
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicFirstName"
                  >
                    Postal Address
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="postal_address"
                    value={usertrackingRec.postal_address}
                    placeholder="Enter Postal Address.."
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            {/* End here Farhan Khan */}
            <Row >
              <Col lg={6}>
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label>Upload Location Pic</Form.Label>
                  <Form.Control
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={handleSiteUpload}
                  />
                  {locationPicFiles.length > 0 && (
                    <Form.Text className="text-muted">
                      {locationPicFiles.length} image(s) selected
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
              <Col lg={12} className="d-flex flex-wrap gap-2">
                {locationPicPreviews.map((preview, index) => (
                  <Image
                    key={`${preview.name}-${index}`}
                    variant="top"
                    src={preview.url}
                    thumbnail
                    alt={preview.name}
                    style={{ width: "150px", height: "150px", objectFit: "cover" }}
                  />
                ))}
              </Col>
            </Row>

            <Row className="my-3">
            <Col lg={4}>
          {/* New Change : here we added the button for navigate to lead create page */}
            <Button variant="primary" onClick={() => { navigate(`/leads/e`) }}>
              Create Lead
            </Button>
          </Col>
              <Col>
                <Button
                  disabled={buttonDisabled}
                  variant='success'
                  onClick={() => handleCheckIn()}
                >
                  Check-In
                </Button>
              </Col>
              <Col>
                <Button
                  disabled={!buttonDisabled}
                  variant='danger'
                  onClick={() => handleCheckOut()}
                >
                  Check-Out
                </Button>
              </Col>
              <Row>

              </Row>
            </Row>
          </Col>
          
        </Row>
      </Container>
    </div>
  )
}

export default UserTracking;